import Filters from "./filters";
import Favorites from "./favorites";
import Tour from "./tour";
import Local from "./local";
import Vote from "./vote";
//import Stats from './stats'

const reducers = {
  Filters,
  Favorites,
  Tour,
  Local,
  Vote,
};

export default reducers;
